import React from "react";
import {
  CssDataJacketTitleTypography,
  CssTableCellUserSupport,
  CssTypographyUserSupport,
} from "../../styles/styled";
import Box from "@mui/material/Box";
import HomeBar from "../../HomeBar";
import { TableRow, Table } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import manual1 from "../../images/manual1.png";
import manual2 from "../../images/manual2.png";
import manual3 from "../../images/manual3.png";
import manual4_1 from "../../images/manual4_1.png";
import manual4_2 from "../../images/manual4_2.png";
import manual4_3 from "../../images/manual4_3.png";
import wave from "../../images/wave.png";
import manual5 from "../../images/manual5.png";
import manual6 from "../../images/manual6.png";
import manual7 from "../../images/manual7.png";
import { useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import SearchIcon from "@mui/icons-material/Search";
import { Link, Events, animateScroll } from "react-scroll";
import Footer from "../../Footer";

const CssLink = styled(Link)({
  color: "white",
  marginLeft: "10px",
  marginBottom: "6px",
  fontSize: "14px",
  "&:hover": {
    backgroundColor: "#75787b",
    cursor: "pointer",
  },
});
const CssLinkTitle = styled(Link)({
  color: "white",
  fontSize: "16px",
  fontWeight: "bold",
  "&:hover": {
    backgroundColor: "#75787b",
    cursor: "pointer",
  },
});

function Manual() {
  const navigate = useNavigate();
  const [offset, setOffset] = React.useState(0);

  function scrollByOffset(element) {
    Events.scrollEvent.register("end", function (to, element) {
      setOffset(-110);
      if (
        offset === 0 &&
        (element.id !== "プライバシー" || element.id !== "利用規約")
      ) {
        animateScroll.scrollMore(-110);
      }
    });
  }

  async function _navigateToPage() {
    navigate("/home");
  }

  return (
    <>
      <HomeBar />
      <div style={{ backgroundColor: "#303234", minWidth: "1200px" }}>
        <Box
          style={{
            position: "fixed",
            zIndex: "10",
            backgroundColor: "#505458",
            width: "300px",
            right: "0",
            top: "120px",
          }}
        >
          <Box
            style={{
              display: "flex",
              flexDirection: "column ",
              padding: "10px",
            }}
          >
            <CssLinkTitle
              activeClass="clsLinkActive"
              smooth
              spy
              to="DATAUNIVERSEについて"
              onClick={scrollByOffset}
              offset={offset}
            >
              DATAUNIVERSEについて
            </CssLinkTitle>
            <CssLinkTitle
              activeClass="clsLinkActive"
              smooth
              spy
              to="DATAUNIVERSEの使い方"
              onClick={scrollByOffset}
              offset={offset}
            >
              DATAUNIVERSEの使い方
            </CssLinkTitle>
            <CssLink
              activeClass="clsLinkActive"
              smooth
              spy
              to="TOP画面"
              onClick={scrollByOffset}
              offset={offset}
            >
              TOP画面
            </CssLink>
            <CssLink
              activeClass="clsLinkActive"
              smooth
              spy
              to="DATA JACKETキーワード検索画面"
              onClick={scrollByOffset}
              offset={offset}
            >
              DATA JACKETキーワード検索画面
            </CssLink>
            <CssLink
              activeClass="clsLinkActive"
              smooth
              spy
              to="DATA JACKET詳細画面"
              onClick={scrollByOffset}
              offset={offset}
            >
              DATA JACKET詳細画面
            </CssLink>
            <CssLink
              activeClass="clsLinkActive"
              smooth
              spy
              to="CONNECT DJ（データネットワーク図）"
              onClick={scrollByOffset}
              offset={offset}
            >
              CONNECT DJ（データネットワーク図）
            </CssLink>
            <CssLink
              activeClass="clsLinkActive"
              smooth
              spy
              to="MY DATA"
              onClick={scrollByOffset}
              offset={offset}
            >
              MY DATA
            </CssLink>
            <CssLinkTitle
              activeClass="clsLinkActive"
              smooth
              spy
              to="プライバシー"
              onClick={scrollByOffset("プライバシー")}
              offset={offset}
            >
              プライバシー
            </CssLinkTitle>
            <CssLinkTitle
              activeClass="clsLinkActive"
              smooth
              spy
              to="利用規約"
              onClick={scrollByOffset("利用規約")}
              offset={offset}
            >
              利用規約
            </CssLinkTitle>
          </Box>
        </Box>
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            position: "sticky",
            zIndex: "4",
            top: "81px",
            backgroundColor: "#303234",
          }}
        >
          <Typography
            style={{
              color: "#00a3e0",
              cursor: "pointer",
              textDecoration: "underline",
              marginLeft: "25px",
            }}
            onClick={_navigateToPage}
          >
            TOP画面
          </Typography>
          <NavigateNextIcon
            style={{
              marginLeft: "8px",
              marginRight: "8px",
              color: "white",
            }}
            fontSize="small"
          />
          <Typography style={{ color: "white" }}>
            DATAUNIVERSEについて・使い方
          </Typography>
        </Box>
        <Box
          style={{
            width: "80%",
          }}
        >
          <Box>
            <CssDataJacketTitleTypography
              style={{
                fontWeight: "bold",
                fontSize: "32px",
                marginLeft: "25px",
              }}
              id="DATAUNIVERSEについて"
            >
              DATAUNIVERSEについて
            </CssDataJacketTitleTypography>
            <Divider
              style={{
                backgroundColor: "white",
              }}
            />
          </Box>
          <Box
            style={{
              paddingLeft: "40px",
            }}
          >
            <CssTypographyUserSupport
              style={{
                color: "white",
                fontSize: "24px",
                paddingTop: "3%",
                paddingBottom: "8%",
                paddingRight: "10%",
              }}
            >
              DATAUNIVERSEは、自社のみで取り組む限界や各種規制の対応の課題を解決しながら、データを起点としたdX推進やコラボレーションの実現を支援
            </CssTypographyUserSupport>
            <Box
              style={{
                display: "flex",
                alignItems: "center", // コンポーネントを垂直方向の中央に配置
                width: "90%", // コンポーネントの幅を全体に設定
                height: "400px",
                position: "relative",
              }}
            >
              <Box
                style={{
                  paddingTop: "30px",
                  display: "flex",
                  flexDirection: "column", // 垂直方向の並び順を指定
                  justifyContent: "space-between",
                  height: "100%",
                  position: "absolute",
                  left: "0",
                  zIndex: "2",
                }}
              >
                <Box
                  style={{
                    float: "left",
                    display: "flex",
                    justifyContent: "center",
                    textAlign: "center",
                    flexDirection: "column",
                  }}
                >
                  <CssTypographyUserSupport>
                    dXアセット群に接続し
                  </CssTypographyUserSupport>
                  <CssTypographyUserSupport>
                    Go-To-Marketをさらに加速
                  </CssTypographyUserSupport>
                </Box>
                <Box
                  style={{
                    float: "left",
                    display: "flex",
                    justifyContent: "center",
                    textAlign: "center",
                    flexDirection: "column",
                  }}
                >
                  <CssTypographyUserSupport>
                    多様なデータへのアクセスが
                  </CssTypographyUserSupport>
                  <CssTypographyUserSupport>
                    コラボレーションを加速し、
                  </CssTypographyUserSupport>
                  <CssTypographyUserSupport>
                    データの優位性を確立
                  </CssTypographyUserSupport>
                </Box>
              </Box>
              <img
                alt="マニュアル1"
                src={manual1}
                style={{
                  width: "40%",
                  objectFit: "cover",
                  position: "absolute",
                  minWidth: "100px",
                  left: "50%",
                  transform: "translate(-50%)",
                  zIndex: "1",
                }}
              />
              <Box
                style={{
                  paddingTop: "30px",
                  display: "flex",
                  flexDirection: "column", // 垂直方向の並び順を指定
                  justifyContent: "space-between",
                  position: "absolute",
                  height: "100%",
                  right: "-20px",
                  zIndex: "2",
                }}
              >
                <Box
                  style={{
                    float: "left",
                    display: "flex",
                    justifyContent: "center",
                    textAlign: "center",
                    flexDirection: "column",
                  }}
                >
                  <CssTypographyUserSupport>
                    データカタログにより
                  </CssTypographyUserSupport>
                  <CssTypographyUserSupport>
                    データ探索とアイデアを発見
                  </CssTypographyUserSupport>
                </Box>
                <Box
                  style={{
                    float: "left",
                    display: "flex",
                    justifyContent: "center",
                    textAlign: "center",
                    flexDirection: "column",
                    paddingBottom: "30px",
                  }}
                >
                  <CssTypographyUserSupport>
                    アイディエーションプログラムで
                  </CssTypographyUserSupport>
                  <CssTypographyUserSupport>
                    ビジネスアイデアを創出
                  </CssTypographyUserSupport>
                </Box>
              </Box>
            </Box>
          </Box>
          <Box
            style={{
              marginTop: "10%",
            }}
          >
            <CssDataJacketTitleTypography
              style={{
                fontWeight: "bold",
                fontSize: "32px",
                marginLeft: "25px",
              }}
              id="DATAUNIVERSEの使い方"
            >
              DATAUNIVERSEの使い方
            </CssDataJacketTitleTypography>
            <Divider
              style={{
                backgroundColor: "white",
              }}
            />
          </Box>
          <Box
            style={{
              marginLeft: "40px",
            }}
          >
            <CssDataJacketTitleTypography
              style={{
                fontWeight: "bold",
                fontSize: "18px",
                marginTop: "20px",
              }}
              id="TOP画面"
            >
              TOP画面
            </CssDataJacketTitleTypography>
            <Divider
              style={{
                backgroundColor: "white",
                marginBottom: "20px",
              }}
            />
            <img
              alt="マニュアル2"
              src={manual2}
              style={{
                marginTop: "25px",
                width: "95%",
                objectFit: "cover",
                boxShadow: "5px 5px 10px rgba(0, 0, 0, 0.5)",
              }}
            />
            <Box
              style={{
                marginLeft: "50px",
                marginTop: "30px",
              }}
            >
              <Table style={{ borderRight: "1px solid white" }}>
                <colgroup>
                  <col style={{ width: "5%" }} />
                  <col style={{ width: "20%" }} />
                  <col style={{ width: "75%" }} />
                </colgroup>
                <TableRow>
                  <CssTableCellUserSupport style={{ textAlign: "center" }}>
                    {"①"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>{"ロゴ"}</CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {
                      "クリックすることで、どの画面からでもTOPページに戻ります。"
                    }
                  </CssTableCellUserSupport>
                </TableRow>
                <TableRow>
                  <CssTableCellUserSupport style={{ textAlign: "center" }}>
                    {"②"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {"The Latest"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {"DATAUNIVESEに関わる最新ニュースを表示します。"}
                  </CssTableCellUserSupport>
                </TableRow>
                <TableRow>
                  <CssTableCellUserSupport style={{ textAlign: "center" }}>
                    {"③"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {"DATA JACKET"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {"クリックでキーワード検索画面に移動します。"}
                  </CssTableCellUserSupport>
                </TableRow>
                <TableRow>
                  <CssTableCellUserSupport style={{ textAlign: "center" }}>
                    {"④"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {"CONNECT DJ"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {
                      "クリックでCONNECT DJ（データネットワーク図）画面に移動します。"
                    }
                  </CssTableCellUserSupport>
                </TableRow>
                <TableRow>
                  <CssTableCellUserSupport style={{ textAlign: "center" }}>
                    {"⑤"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>{"MY DATA"}</CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {"保存したユーザーデータを確認できます。"}
                  </CssTableCellUserSupport>
                </TableRow>
                <TableRow>
                  <CssTableCellUserSupport style={{ textAlign: "center" }}>
                    {"⑥"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>{"CONTACT"}</CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {
                      "本サイトについてご質問のある方は、こちらからメールにてご連絡ください。"
                    }
                  </CssTableCellUserSupport>
                </TableRow>
                <TableRow>
                  <CssTableCellUserSupport style={{ textAlign: "center" }}>
                    {"⑦"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {"プロファイル"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {"パスワード変更やログアウトが行えます。"}
                  </CssTableCellUserSupport>
                </TableRow>
              </Table>
              <div style={{ fontSize: "16px", padding: "5px", color: "white" }}>
                ※webブラウザの戻るボタンは使用しないようにお願いします。
              </div>
            </Box>
            <CssDataJacketTitleTypography
              style={{
                fontWeight: "bold",
                fontSize: "18px",
                marginTop: "20px",
              }}
              id="DATA JACKETキーワード検索画面"
            >
              DATA JACKETキーワード検索画面
            </CssDataJacketTitleTypography>
            <Divider
              style={{
                backgroundColor: "white",
                marginBottom: "20px",
              }}
            />
            <img
              alt="マニュアル3"
              src={manual3}
              style={{
                marginTop: "25px",
                width: "95%",
                objectFit: "cover",
                boxShadow: "5px 5px 10px rgba(0, 0, 0, 0.5)",
              }}
            />
            <Box
              style={{
                marginLeft: "50px",
                marginTop: "30px",
              }}
            >
              <Table style={{ borderRight: "1px solid white" }}>
                <colgroup>
                  <col style={{ width: "5%" }} />
                  <col style={{ width: "20%" }} />
                  <col style={{ width: "75%" }} />
                </colgroup>
                <TableRow>
                  <CssTableCellUserSupport style={{ textAlign: "center" }}>
                    {"①"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {"検索条件"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {"各種検索条件を入力し、"}
                    <SearchIcon
                      style={{ fontSize: "unset", verticalAlign: "middle" }}
                    />
                    {"をクリックしてデータ検索します。"}
                  </CssTableCellUserSupport>
                </TableRow>
                <TableRow>
                  <CssTableCellUserSupport style={{ textAlign: "center" }}>
                    {"②"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {"DATA JACKET"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {"クリックで詳細画面に移動します。"}
                  </CssTableCellUserSupport>
                </TableRow>
                <TableRow>
                  <CssTableCellUserSupport style={{ textAlign: "center" }}>
                    {"③"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {"お気に入り登録"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {
                      "♡をクリックすることでお気に入り登録ができ、検索条件として使用します。"
                    }
                  </CssTableCellUserSupport>
                </TableRow>
              </Table>
            </Box>
            <CssDataJacketTitleTypography
              style={{
                fontWeight: "bold",
                fontSize: "18px",
                marginTop: "20px",
              }}
              id="DATA JACKET詳細画面"
            >
              DATA JACKET詳細画面
            </CssDataJacketTitleTypography>
            <Divider
              style={{
                backgroundColor: "white",
                marginBottom: "20px",
              }}
            />
            <Box>
              <img
                alt="マニュアル4"
                src={manual4_1}
                style={{
                  marginTop: "25px",
                  width: "95%",
                  objectFit: "cover",
                  boxShadow: "5px 0px 10px rgba(0, 0, 0, 0.5)",
                  position: "relative",
                  zIndex: "1",
                }}
              />
              <img
                alt="マニュアル4"
                src={wave}
                style={{
                  width: "100%",
                  objectFit: "cover",
                  position: "relative",
                  zIndex: "2",
                  right: "30px",
                  bottom: "20px",
                }}
              />
              <img
                alt="マニュアル4"
                src={manual4_2}
                style={{
                  width: "95%",
                  objectFit: "cover",
                  boxShadow: "5px 0px 10px rgba(0, 0, 0, 0.5)",
                  position: "relative",
                  zIndex: "1",
                  bottom: "40px",
                }}
              />
              <img
                alt="マニュアル4"
                src={wave}
                style={{
                  width: "100%",
                  objectFit: "cover",
                  position: "relative",
                  right: "30px",
                  bottom: "60px",
                  zIndex: "2",
                }}
              />
              <img
                alt="マニュアル4"
                src={manual4_3}
                style={{
                  width: "95%",
                  objectFit: "cover",
                  boxShadow: "5px 5px 10px rgba(0, 0, 0, 0.5)",
                  position: "relative",
                  bottom: "80px",
                  zIndex: "1",
                }}
              />
            </Box>
            <Box
              style={{
                marginLeft: "50px",
                marginTop: "-50px",
              }}
            >
              <Table style={{ borderRight: "1px solid white" }}>
                <colgroup>
                  <col style={{ width: "5%" }} />
                  <col style={{ width: "20%" }} />
                  <col style={{ width: "75%" }} />
                </colgroup>
                <TableRow>
                  <CssTableCellUserSupport style={{ textAlign: "center" }}>
                    {"①"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {"データジャケット情報"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {
                      "データ概要、収集方法、分析方法例等のメタデータを表示します。"
                    }
                  </CssTableCellUserSupport>
                </TableRow>
                <TableRow>
                  <CssTableCellUserSupport style={{ textAlign: "center" }}>
                    {"②"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {"CONNECT DJ"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {
                      "クリックでCONNECT DJ（データネットワーク図）画面に移動します。"
                    }
                  </CssTableCellUserSupport>
                </TableRow>
                <TableRow>
                  <CssTableCellUserSupport style={{ textAlign: "center" }}>
                    {"③"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {"お気に入り登録"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {"♡をクリックすることでお気に入り登録します。"}
                  </CssTableCellUserSupport>
                </TableRow>
                <TableRow>
                  <CssTableCellUserSupport style={{ textAlign: "center" }}>
                    {"④"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>{"目次"}</CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {"詳細画面のページ構成を表示します。"}
                    <br />
                    {"クリックで該当ページへジャンプします。"}
                  </CssTableCellUserSupport>
                </TableRow>
                <TableRow>
                  <CssTableCellUserSupport style={{ textAlign: "center" }}>
                    {"⑤"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {"データセット情報"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {
                      "本データに含まれるデータセットについてのメタデータを表示します。"
                    }
                    <br />
                    {"プルダウンで、データセットの切り替えができます。"}
                  </CssTableCellUserSupport>
                </TableRow>
                <TableRow>
                  <CssTableCellUserSupport style={{ textAlign: "center" }}>
                    {"⑥"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {"データコンテンツ"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {"データセットのサンプル、ヒストグラム等を表示します。"}
                  </CssTableCellUserSupport>
                </TableRow>
                <TableRow>
                  <CssTableCellUserSupport style={{ textAlign: "center" }}>
                    {"⑦"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {"項目説明"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {"データセットの各項目の概要と基礎統計量を表示します。"}
                  </CssTableCellUserSupport>
                </TableRow>
                <TableRow>
                  <CssTableCellUserSupport style={{ textAlign: "center" }}>
                    {"⑧"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {"データに関する問い合わせ先"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {
                      "本データに関してのご質問、購入の相談などはこちらにご連絡ください。"
                    }
                  </CssTableCellUserSupport>
                </TableRow>
              </Table>
            </Box>
            <CssDataJacketTitleTypography
              style={{
                fontWeight: "bold",
                fontSize: "18px",
                marginTop: "20px",
              }}
              id="CONNECT DJ（データネットワーク図）"
            >
              CONNECT DJ（データネットワーク図）
            </CssDataJacketTitleTypography>
            <Divider
              style={{
                backgroundColor: "white",
                marginBottom: "20px",
              }}
            />
            <img
              alt="マニュアル5"
              src={manual5}
              style={{
                marginTop: "25px",
                width: "95%",
                objectFit: "cover",
                boxShadow: "5px 5px 10px rgba(0, 0, 0, 0.5)",
              }}
            />
            <Box
              style={{
                marginLeft: "50px",
                marginTop: "30px",
              }}
            >
              <Table style={{ borderRight: "1px solid white" }}>
                <colgroup>
                  <col style={{ width: "5%" }} />
                  <col style={{ width: "20%" }} />
                  <col style={{ width: "75%" }} />
                </colgroup>
                <TableRow>
                  <CssTableCellUserSupport style={{ textAlign: "center" }}>
                    {"①"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>{"ノード"}</CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {
                      "関連したデータが緑点でプロットされ、データ名称が表示されます。"
                    }
                    <br />
                    {
                      "緑点を右クリックで、選択したデータの概要情報表示、関連データ検索等が行えます。"
                    }
                  </CssTableCellUserSupport>
                </TableRow>
                <TableRow>
                  <CssTableCellUserSupport style={{ textAlign: "center" }}>
                    {"②"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>{"エッジ"}</CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {
                      "データ間を紐づける線として表示され、関連性が高いほど赤くなります。"
                    }
                    <br />
                    {"マウスオーバーで類似度、関連キーワードが表示されます。"}
                  </CssTableCellUserSupport>
                </TableRow>
                <TableRow>
                  <CssTableCellUserSupport style={{ textAlign: "center" }}>
                    {"③"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {"データ概要情報"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {"選択したデータの概要情報が表示されます。"}
                  </CssTableCellUserSupport>
                </TableRow>
                <TableRow>
                  <CssTableCellUserSupport style={{ textAlign: "center" }}>
                    {"④"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {"詳細画面"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {"クリックで詳細画面に移動します。"}
                  </CssTableCellUserSupport>
                </TableRow>
                <TableRow>
                  <CssTableCellUserSupport style={{ textAlign: "center" }}>
                    {"⑤"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {"画像出力"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {"作成したネットワーク図を画像出力します。"}
                  </CssTableCellUserSupport>
                </TableRow>
                <TableRow>
                  <CssTableCellUserSupport style={{ textAlign: "center" }}>
                    {"⑥"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>{"保存"}</CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {"作成したネットワーク図をMY DATAに保存します。"}
                  </CssTableCellUserSupport>
                </TableRow>
                <TableRow>
                  <CssTableCellUserSupport style={{ textAlign: "center" }}>
                    {"⑦"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>{"新規"}</CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {"作成中のネットワーク図を破棄し、新規作成します。"}
                  </CssTableCellUserSupport>
                </TableRow>
              </Table>
            </Box>
            <CssDataJacketTitleTypography
              style={{
                fontWeight: "bold",
                fontSize: "18px",
                marginTop: "20px",
              }}
              id="MY DATA"
            >
              MY DATA
            </CssDataJacketTitleTypography>
            <Divider
              style={{
                backgroundColor: "white",
                marginBottom: "20px",
              }}
            />
            <img
              alt="マニュアル6"
              src={manual6}
              style={{
                marginTop: "25px",
                width: "95%",
                objectFit: "cover",
                boxShadow: "5px 5px 10px rgba(0, 0, 0, 0.5)",
              }}
            />
            <img
              alt="マニュアル7"
              src={manual7}
              style={{
                marginTop: "25px",
                width: "95%",
                objectFit: "cover",
                boxShadow: "5px 5px 10px rgba(0, 0, 0, 0.5)",
              }}
            />
            <Box
              style={{
                marginLeft: "50px",
                marginTop: "30px",
              }}
            >
              <Table style={{ borderRight: "1px solid white" }}>
                <colgroup>
                  <col style={{ width: "5%" }} />
                  <col style={{ width: "20%" }} />
                  <col style={{ width: "75%" }} />
                </colgroup>
                <TableRow>
                  <CssTableCellUserSupport style={{ textAlign: "center" }}>
                    {"①"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {"DATA JACKET"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {"個別に登録したデータ"}
                  </CssTableCellUserSupport>
                </TableRow>
                <TableRow>
                  <CssTableCellUserSupport style={{ textAlign: "center" }}>
                    {"②"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {"CONNECT DJ"}
                  </CssTableCellUserSupport>
                  <CssTableCellUserSupport>
                    {"CONNECT DJ画面で保存したネットワーク図"}
                  </CssTableCellUserSupport>
                </TableRow>
              </Table>
            </Box>
          </Box>
          <Box
            style={{
              marginTop: "10%",
            }}
          >
            <CssDataJacketTitleTypography
              style={{
                fontWeight: "bold",
                fontSize: "32px",
              }}
              id="プライバシー"
            >
              プライバシー
            </CssDataJacketTitleTypography>
            <Divider
              style={{
                backgroundColor: "white",
              }}
            />
          </Box>
          <Box
            style={{
              paddingLeft: "40px",
            }}
          >
            <CssTypographyUserSupport
              style={{
                color: "white",
                fontSize: "16px",
                paddingTop: "30px",
                paddingBottom: "60px",
              }}
            >
              <a
                href="https://www2.deloitte.com/jp/ja/footerlinks1/privacy/privacy-for-other-sites.html"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "rgb(0, 163, 224)" }}
              >
                https://www2.deloitte.com/jp/ja/footerlinks1/privacy/privacy-for-other-sites.html
              </a>
            </CssTypographyUserSupport>
          </Box>
          <Box>
            <CssDataJacketTitleTypography
              style={{
                fontWeight: "bold",
                fontSize: "32px",
              }}
              id="利用規約"
            >
              利用規約
            </CssDataJacketTitleTypography>
            <Divider
              style={{
                backgroundColor: "white",
              }}
            />
          </Box>
          <Box
            style={{
              paddingLeft: "40px",
            }}
          >
            <CssTypographyUserSupport
              style={{
                color: "white",
                fontSize: "16px",
                paddingTop: "30px",
                paddingBottom: "100px",
              }}
            >
              ※随時追加
            </CssTypographyUserSupport>
          </Box>

          <Box
            style={{
              marginBottom: "40px",
            }}
          ></Box>
        </Box>
      </div>
      <Footer />
    </>
  );
}

export default Manual;
